/**
 * FEAT-087 / S-375 — what binds a voice profile, and how loudly to say it.
 *
 * Three states, in the prototype's own order: publications, else an amplifier's
 * voice override, else nothing.
 *
 * **"Not in use" is quiet on purpose.** The handoff lists it beside "Published"
 * as a neutral state that keeps a grey wash "so quiet states stay quiet". An
 * unused voice profile is a fact about the library — not a fault in a
 * publication, which is what the redesign's amber is for. The word "untested"
 * belongs to the editor, where it means no piece has been scored against the
 * profile; it is not a synonym for unbound.
 *
 * Pure, so the rule is tested without the view's data fetching.
 */
export function voiceUsage(
  publications: number,
  amplifiers: number
): { label: string; inUse: boolean } {
  if (publications > 0) {
    return {
      label: `Used by ${publications} publication${publications === 1 ? "" : "s"}`,
      inUse: true,
    };
  }
  if (amplifiers > 0) {
    return {
      label: `Used by ${amplifiers} amplifier${amplifiers === 1 ? "" : "s"}`,
      inUse: true,
    };
  }
  return { label: "Not in use", inUse: false };
}
